import { Button, Grid, Menu, MenuItem } from "@material-ui/core";
import React, { useState } from "react";
import i18next from "../../assets/i18n/i18n";
import PortimaLogo from "../logos/portima-logo";
import "./header.scss";
import LanguageLogo from "../../assets/images/png/LanguageLogo.png";
import DownArrow from "../../assets/images/png/DownArrow.png";

type Props = {
    onChangeLanguage: (language: string) => void;
};

const PortimaHeader = ({ onChangeLanguage }: Props): React.ReactElement => {
    const language = i18next.language.toUpperCase();

    const [dropDownOpen, setDropDownOpen] = useState(false);
    const [anchorRef] = useState(React.createRef<any>());

    const handleClick = (event: any) => {
        setDropDownOpen(true);
    };

    const setLanguage = (lang: string) => {
        onChangeLanguage(lang);
        setDropDownOpen(false);
    };

    return (
        <Grid container justifyContent="center" className="header-login-container">
            <Grid item xs={1} />
            <Grid item xs>
                <PortimaLogo paddingTop="0" />
            </Grid>
            <Grid item xs />
            <Grid item xs={1}>
                <Button
                    ref={anchorRef}
                    id="btn-internationalization"
                    variant="contained"
                    className="header-login-internationalization"
                    aria-haspopup="true"
                    aria-controls="simple-menu"
                    startIcon={<img src={LanguageLogo} alt="logo representing the internationalization" />}
                    endIcon={<img src={DownArrow} alt="down arrow" />}
                    onClick={(event) => handleClick(event)}
                >
                    {language}
                </Button>
                <Menu id="menu-internationalization" anchorEl={anchorRef.current} open={dropDownOpen} keepMounted>
                    <MenuItem id="menu-item-internationalization-fr" onClick={() => setLanguage("fr")}>
                        FR
                    </MenuItem>
                    <MenuItem id="menu-item-internationalization-nl" onClick={() => setLanguage("nl")}>
                        NL
                    </MenuItem>
                </Menu>
            </Grid>
            <Grid item xs={1} />
        </Grid>
    );
};

export default PortimaHeader;
